import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ChatService } from '../../../services/chat.service';

@Component({
  selector: 'app-message-timestamp',
  templateUrl: './message-timestamp.component.html',
  styleUrls: ['./message-timestamp.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class MessageTimestampComponent implements OnInit {
  @Input() createdAt: number = 0;
  @Input() textAlign: string = 'left';
  constructor(private chatService: ChatService) {}

  createdTimestamp: string = '';

  get configs() {
    return this.chatService.configs;
  }

  ngOnInit() {
    this.createdTimestamp = this.getDateString(this.createdAt);
  }

  private getDateString(time: number) {
    if (time <= 0) return '';

    const date = new Date(time);

    const formattedDate = `${('0' + date.getDate()).slice(
      -2
    )}-${date.toLocaleString('default', {
      month: 'short',
    })}-${date.getFullYear()} ${('0' + date.getHours()).slice(-2)}:${(
      '0' + date.getMinutes()
    ).slice(-2)}`;

    return formattedDate;
  }
}
